import React, { Component } from 'react';
import { NavLink, NavbarBrand, Collapse, Navbar, NavItem, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
/*import './NavMenu.css';*/

import '../assets/css/bootstrap.min.css';
/////*< !--Libraries Stylesheet-- >*/
//import '../assets/lib/owlcarousel/assets/owl.carousel.min.css';
import '../assets/lib/animate/animate.min.css';


export class NavMenu extends Component {
  static displayName = NavMenu.name;


  render() {
      return (
        <div>

              {/*<!-- Spinner Start -->*/}
              {/*<div id="spinner" class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">*/}
              {/*    <div class="spinner"></div>*/}
              {/*</div>*/}
              {/*<!-- Spinner End -->*/}


              {/*<!-- Topbar Start -->*/}
              <div class="container-fluid bg-dark px-5 d-none d-lg-block">
                  <div class="row gx-0">
                      <div class="col-lg-4 text-center text-lg-start mb-2 mb-lg-0">
                          <div class="top-section d-inline-flex align-items-center">
                              <small class="me-4 text-light"><i class="bi bi-telephone-plus me-2"></i>+254 792 188 931 | +254 792 026 263</small>
                              <small class="me-4 text-light"><i class="bi bi-envelope me-2"></i>info@jewstechs.com</small>
                              <small class="me-4 text-light"><i class="bi bi-clock me-2"></i>24/7 Service</small>
                          </div>
                      </div>
                      <div class="col-lg-8 text-center text-lg-end">
                          <div class="top-section d-inline-flex align-items-center">
                              <small class="tr-text me-4 text-light">Networking</small>
                              <small class="tr-text me-4 text-light">CCTV & Access Control</small>
                              <small class="tr-text me-4 text-light">IT Infrastructure Management</small>
                              <small class="tr-text me-4 text-light">ICT consultation</small>
                          </div>
                      </div>
                  </div>
              </div>
              {/*<!-- Topbar End -->*/}

              {/*<!-- Navbar & Carousel Start -->*/}
              <div class="container-fluid position-relative p-0">
                  <nav class="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0s">
                      <NavbarBrand tag={Link} className="navbar-brand p-0" to="/">
                          <h1 class="m-0 fs-1">
                          <span class="jj">J</span>
                          <span class="ee">e</span>
                          <span class="ww">w</span>
                          <span class="sa">s</span>
                          <span class="tt">t</span>
                          <span class="ea">e</span>
                          <span class="cc">c</span>
                          <span class="hh">h</span>
                          <span class="sa">s</span>

                          <span class="jj ltd-space">L</span>
                          <span class="sa">t</span>
                          <span class="ea">d</span>
                          </h1>
                      </NavbarBrand>
                      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                          <span class="fa fa-bars"></span>
                      </button>
                      <div class="collapse navbar-collapse" id="navbarCollapse">
                          <div class="navbar-nav ms-auto py-0">
                              <NavLink tag={Link} className="nav-item nav-link active" to="/">home</NavLink>
                              <NavLink tag={Link} className="nav-item nav-link" to="/aboutus">about</NavLink>
                              <NavLink tag={Link} className="nav-item nav-link" to="/services">services</NavLink>
                              <NavLink tag={Link} className="nav-item nav-link" to="/faqs">faqs</NavLink>
                              <NavLink tag={Link} className="nav-item nav-link" to="/blog">blog</NavLink>
                              <NavLink tag={Link} className="nav-item nav-link" to="/keyareas">key areas</NavLink>
                              {/*<div class="nav-item dropdown">*/}
                              {/*    <NavLink className="nav-link dropdown-toggle" data-bs-toggle="dropdown">our projects</NavLink>*/}
                              {/*    <div class="dropdown-menu">*/}
                              {/*        <NavLink tag={Link} className="dropdown-itemer text-primary" to="/projects">projects</NavLink>*/}
                              {/*    </div>*/}
                              {/*</div>*/}
                              <NavLink tag={Link} className="nav-item nav-link" to="/contactus">contact us</NavLink>
                          </div>
                      </div>
                  </nav>

              </div>
              {/*<!-- Navbar & Carousel End -->*/}              

        </div>
    );
  }
}
